import { ScheduleStatus, ScheduleType } from "enums/schedule.enum";
import { IScheduleRowViewModel } from "types/schedule";

/** One page of schedules for the table's cursor pagination. */
export const SCHEDULES_PAGE_SIZE = 6;

/**
 * Page size the full drain requests. Deliberately separate from the table's page size - the
 * drain keeps following the next-cursor until the backend stops issuing one, so this only
 * controls how many round trips that takes, not what the user sees.
 */
export const SCHEDULES_DRAIN_PAGE_SIZE = 15;

export interface ISchedulesQuery {
    pageSize: number;
    status?: string;
    type?: string;
    startKey?: string | null;
    total?: number;
}

export interface ISchedulesPage {
    rows: IScheduleRowViewModel[];
    total: number;
    nextStartKey: string | null;
}

export interface IGetAllSchedulesOptions {
    status?: ScheduleStatus;
    type?: ScheduleType;
    signal?: AbortSignal;
}

export interface IScheduleSummary {
    totalSchedules: number;
    activeSchedules: number;
    failedSchedules: number;
    stalledSchedules: number;
    taskSuccessRatePercent: number;
}

/**
 * What the Schedule Monitor page needs from the backend. `getSummary` is optional and
 * intentionally unimplemented until the API exposes it - the page checks for its presence
 * and renders em-dashes when absent, rather than gating on a feature flag.
 */
export interface ISchedulesRepository {
    getSchedules(query: ISchedulesQuery): Promise<ISchedulesPage>;
    getAllSchedules(options?: IGetAllSchedulesOptions): Promise<IScheduleRowViewModel[]>;
    getSummary?(): Promise<IScheduleSummary>;
}

export default ISchedulesRepository;
